import React, { Component } from 'react'
import styled from 'styled-components'

// Must pass in 2 p tags
class CustomBlockQuote extends Component {
  render() {
    const { children, mobile } = this.props
    const quote = children[0]
    const attribution = children[1]
    return (
      <CustomBlockQuoteContainer>
        {quote}
        {attribution}
      </CustomBlockQuoteContainer>
    )
  }
}

export default CustomBlockQuote

const CustomBlockQuoteContainer = styled.div`
  margin: 30px 0;
  position: relative;
  &::before {
    content: '\\201C'; /*Unicode for Left Double Quote*/
    /*Font*/
    font-family: Georgia, serif;
    font-size: 8rem;
    font-weight: bold;
    color: rgba(37, 56, 88, 0.75);
    /*Positioning*/
    position: absolute;
    left: -10px;
    top: -20px;
  }
  p:first-child {
    font-size: 2.2rem;
    margin-bottom: 20px;
    position: relative;
    top: 25px;
  }

  p:nth-child(2) {
    font-size: 2rem;
    position: relative;
    top: 25px;
  }

  @media screen and (max-width: 768px) {
    margin: auto;
    font-size: 2rem;
    position: relative;

    p:first-child {
      font-size: 1.6rem;
      margin-bottom: 0;
      position: relative;
      margin-bottom: 10px;
    }

    p:nth-child(2) {
      font-size: 1.6rem;
      position: relative;
      font-weight: 600;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/UI/blockquote.jsx